import { Component } from '@angular/core';
import { CloudResource } from '../../../decorators/cloud-resource';
import { CloudProviderPluginComponent } from '../wizard-plugins/cloud-provider-plugin/cloud-provider-plugin.component';
import { SoftwareConfigPluginComponent } from '../wizard-plugins/software-config-plugin/software-config-plugin.component';
import { TemplateDetailsComponent } from '../wizard-plugins/template-details/template-details.component';
import { RequisitionPluginComponent } from '../../entities/requisition/plugins/requisition-plugin/requisition-plugin.component';
import { TrainingSchedulesPluginComponent } from '../../entities/requisition/plugins/training-schedules-plugin/training-schedules-plugin.component';
import { AdditionalInformationPluginComponent } from '../../entities/requisition/plugins/additional-information-plugin/additional-information-plugin.component';
import { RequisitionEntityService } from '../../../services/entity-services/requisition-entity.service';
import { REQUISITION_ENTITY_SERVICE_TOKEN, REQUISITION_WIZARD_SERVICE_TOKEN } from '../../../injection-tokens/entity-service-tokens';

@CloudResource({
  name: 'Virtual Machine',
  type: 'vm',
  description: `Create a virtual machine`,
  plugins: [
    TemplateDetailsComponent,
    CloudProviderPluginComponent,
    SoftwareConfigPluginComponent,
  ],
  showOnResourceCreator: true
})
@Component({
  selector: 'app-virtual-machine',
  templateUrl: './virtual-machine.component.html',
  styleUrls: ['./virtual-machine.component.css']
})
export class VirtualMachineComponent {
  constructor() {
  }
}

@CloudResource({
  name: 'Requisition',
  type: '',
  description: ``,
  plugins: [RequisitionPluginComponent,
    // BillingDetailsPluginComponent,
    TrainingSchedulesPluginComponent,
    AdditionalInformationPluginComponent
  ],
  service: RequisitionEntityService,
  injectionToken: REQUISITION_WIZARD_SERVICE_TOKEN,
  afterCreateRoute:"/requisitions",
  showOnResourceCreator: false
})
@Component({
  selector: 'app-requisition',
  template: "<h1>Requisition Component</h1>",
  styleUrls: ['./virtual-machine.component.css']
})
export class RequisitionCreateComponent {

}
